// extracted by mini-css-extract-plugin
export default {"container":"Oda-z","heading":"Pda-z","links":"Qda-z","linkBtn":"Rda-z","disabled":"Sda-z","linkUppercaseBold":"Tda-z","copy":"Uda-z","subCopy":"Vda-z"};